import { Plugin } from "..";
import { defaultVibrationEventSummaryDataOptions } from "./vibration-event-summary-data-options";
import { defaultVibrationEventSummaryOptions } from "./vibration-event-summary-options";

export const VibrationEventSummary: Plugin = {
	id: "vibration-event-summary",
	type: "event",
	header: {
		visible: true,
		edit: false,
		fullscreen: false,
	},
	name: "vibrationEventSummary",
	component: defineAsyncComponent(() => import("./VibrationEventSummaryPlugin")),
	config: defineAsyncComponent(() => import("./VibrationEventSummaryPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./VibrationEventSummaryDataConfig.vue")),
	defaultDataResolver: () => defaultVibrationEventSummaryDataOptions,
	defaultOptionsResolver: () => defaultVibrationEventSummaryOptions,
	dimension: {
		minHeight: 4,
		minWidth: 4,
	},

	currentVersion: 1,
	migrations: {},
};
